import { useEffect, useContext, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { ModalContractuales } from "./modalForm/modalForm";
import { DataContext } from "../contextData/contextData";
import { UseModalForm } from "./modalForm/useModalForm";
import { useIndex } from "./useIndex";
import { ColaboradorResumen } from "./components/ColaboradorResumen";
import { OpcionesCambioCards } from "./components/OpcionesCambioCards";

export const Index = ({ modulo }) => {
  const { uno, setNombreMenu } = useContext(DataContext);
  const { traerData, filtrarUno, arrData, objTipoContrato, formatFecha } = useIndex();
  const { visible, hideModal, dataModal, procesoSelected } = UseModalForm();

  useEffect(() => {
    traerData();
    setNombreMenu("Iniciar solicitud");
  }, []);

  useLayoutEffect(() => {
    filtrarUno();
  }, []);

  return (
    <>
      <ModalContractuales
        data={dataModal}
        show={visible}
        hideModal={hideModal}
        cambioSelected={procesoSelected}
      />
      <div className="d-flex align-items-center flex-column py-3">
        <ColaboradorResumen
          arrData={arrData}
          filtrarUno={filtrarUno}
          uno={uno}
          formatFecha={formatFecha}
          objTipoContrato={objTipoContrato}
        />
        <OpcionesCambioCards
          uno={uno}
          modulo={modulo}
          hideModal={hideModal}
        />
      </div>
    </>
  );
};

Index.propTypes = {
  modulo: PropTypes.string,
};
